import React from 'react';
import { Clapperboard, CheckCircle, Film } from 'lucide-react';
import { VideoAssetCard } from './VideoAssetCard';
import { PlanningDocumentCard } from './PlanningDocumentCard';
import { DEMO_LIBRARY_VIDEO_THUMB } from './demoStockImages';

/**
 * Single deliverable card that morphs by workflow stage: planning → video → draft → published.
 */
export function WorkflowMorphCard({ stageId, planning, media, draft, published }) {
  if (stageId === 'planning') {
    return (
      <PlanningDocumentCard
        title={planning.item}
        meta={planning.desc}
        accentColor={planning.color}
        variant="workflow"
        className="mkt-workflow-morph-card mkt-workflow-morph-card--planning"
      />
    );
  }

  if (stageId === 'media') {
    return (
      <VideoAssetCard
        title={media.item}
        meta={media.desc}
        duration="2:14"
        thumbnailUrl={DEMO_LIBRARY_VIDEO_THUMB}
        thumbnailLoading="eager"
        showLibraryBadge
        badgeLabel="Library video"
        badgeIcon={Film}
        badgeTone="library"
        className="mkt-workflow-morph-card mkt-workflow-morph-card--video"
      />
    );
  }

  if (stageId === 'draft') {
    return (
      <VideoAssetCard
        title={draft.item}
        meta={draft.desc}
        duration="0:28"
        thumbnailUrl={DEMO_LIBRARY_VIDEO_THUMB}
        thumbnailLoading="eager"
        showLibraryBadge
        badgeLabel="Instagram · Draft"
        badgeIcon={Clapperboard}
        badgeTone="draft"
        className="mkt-workflow-morph-card mkt-workflow-morph-card--draft"
      />
    );
  }

  return (
    <VideoAssetCard
      title={published.item}
      meta={published.desc}
      thumbnailUrl={DEMO_LIBRARY_VIDEO_THUMB}
      thumbnailLoading="eager"
      showLibraryBadge
      badgeLabel="Published"
      badgeIcon={CheckCircle}
      badgeTone="published"
      showPlay={false}
      showDuration={false}
      thumbOverlayIcon={CheckCircle}
      className="mkt-workflow-morph-card mkt-workflow-morph-card--published"
    />
  );
}
